module.exports = __webpack_public_path__ + "img/11452424000375.e8a44992.png";